import { Route, UrlMatchResult, UrlSegment, UrlSegmentGroup } from '@angular/router';
import { CONTENT_FEATURES } from '@23degrees/shared/services/content/content-access.constants';

export function foldersPageMatcher(url: UrlSegment[], group: UrlSegmentGroup, route: Route): UrlMatchResult {
  const folderPages = ['collections', 'folders', 'shared', 'recent', 'trash', 'favorites'];

  if (url.length < 1) return null;
  if (!folderPages.includes(url[0].path)) return null;

  const urlMath: UrlMatchResult = { consumed: url, posParams: {} };
  urlMath.posParams['root'] = url[0];

  for (let idx = 1; idx < url.length; idx++) {
    urlMath.posParams[`folder-${idx}`] = url[idx];
  }

  return urlMath; //{ consumed: url, posParams: posParams };
}

export function contentMatcher(url: UrlSegment[], group: UrlSegmentGroup, route: Route) {
  // view/:slug/child?
  // viewSub/:slug/:child
  // edit/:slug/:child?/:editor?
  // editSub/:slug/:child/:editor?
  // export/:slug/:type
  // export/:slug/:child?/:type
  // exportSub/:slug/:child/:type

  if (url.length < 2) return null;
  const mode = url[0].path;
  // if (!['view', 'viewSub', 'edit', 'editSub', 'data', 'dataSub'].includes(mode)) return null;
  if (!['view', 'viewSub', 'edit', 'editSub', 'export', 'exportSub', 'data', 'dataSub'].includes(mode)) return null;

  const exportModes = ['export', 'exportSub'];

  const posParams = {};
  posParams['mode'] = url[0];
  posParams['slug'] = url[1];

  if (!exportModes.includes(mode)) {
    if (url.length >= 3) {
      if (url[2].path.startsWith('edit-')) {
        posParams['editor'] = url[2];
      } else {
        posParams['child'] = url[2];
      }
    }

    if (url.length >= 4) {
      posParams['child'] = url[2];
      posParams['editor'] = url[3];
    }
  }

  if (exportModes.includes(mode)) {
    const types = CONTENT_FEATURES.filter((feature) => feature.url).map((feature) => feature.url);
    if (url.length > 3) {
      posParams['exportType'] = url[3];
      posParams['child'] = url[2];
    }
    if (url.length === 3) {
      if (types.includes(url[2].path)) {
        posParams['exportType'] = url[2];
      } else {
        posParams['child'] = url[2];
      }
    }
  }

  return { consumed: url, posParams: posParams };
}
